import React from 'react';
import { Link } from 'react-router-dom';
import { Mail } from 'lucide-react';
import { RiversideMark } from './brand/RiversideMark';
import { useCelestialMode } from '../hooks/useCelestialMode';
import { isSharedTransfersEnabled } from '../config/features';
import { PopularRouteLinks } from './PopularRoutes';

import { BOOKING_EMAIL } from '../config/contact';
import { reopenConsent } from '../config/consent';

const Footer = () => {
  const celestialMode = useCelestialMode();
  const sharedEnabled = isSharedTransfersEnabled();

  const quickLinks = [
    { to: '/bus', label: 'Bus Tickets' },
    { to: '/schedule', label: 'Timetable' },
    { to: '/private-transfer', label: 'Private Transfer' },
    ...(sharedEnabled
      ? [
          { to: '/trips', label: 'Browse Trips' },
          { to: '/create', label: 'Start a shared trip' },
        ]
      : []),
    { to: '/my-trips', label: 'My Trips' },
  ];

  return (
    <footer className="bg-[#2D1E17] text-white py-16 pb-[calc(4rem+env(safe-area-inset-bottom))] md:pb-16">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid md:grid-cols-5 gap-12 mb-12">
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center gap-2 mb-6">
              <div className="p-2 rounded-lg bg-[#A44432]">
                <RiversideMark mode={celestialMode} className="h-[30px] w-12 text-white shrink-0" />
              </div>
              <span className="text-2xl font-bold font-serif">Riverside</span>
            </div>
            <p className="text-stone-400 max-w-sm mb-6">
              Scheduled buses and private vehicles between Nairobi, Arusha, and Moshi. Our drivers
              run these roads every week — book online and travel at the price you were quoted.
            </p>
            <a
              href={`mailto:${BOOKING_EMAIL}`}
              className="inline-flex items-center gap-2 text-sm text-stone-300 hover:text-white transition-colors"
            >
              <Mail size={16} />
              {BOOKING_EMAIL}
            </a>
          </div>
          <div>
            <h4 className="font-bold mb-6 uppercase text-xs tracking-widest text-[#A44432]">Quick Links</h4>
            <ul className="space-y-4 text-sm text-stone-400">
              {quickLinks.map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="hover:text-white transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-bold mb-6 uppercase text-xs tracking-widest text-[#A44432]">Popular Routes</h4>
            <PopularRouteLinks />
          </div>
          <div>
            <h4 className="font-bold mb-6 uppercase text-xs tracking-widest text-[#A44432]">Company</h4>
            <ul className="space-y-4 text-sm text-stone-400">
              <li><Link to="/booking-conditions" className="hover:text-white transition-colors">Booking Conditions</Link></li>
              <li><Link to="/privacy" className="hover:text-white transition-colors">Privacy Policy</Link></li>
              <li><Link to="/offices" className="hover:text-white transition-colors">Offices &amp; contact</Link></li>
              <li><Link to="/border-crossing" className="hover:text-white transition-colors">Border Crossing Guide</Link></li>
              <li><a href={`mailto:${BOOKING_EMAIL}`} className="hover:text-white transition-colors">Contact Support</a></li>
              <li className="text-stone-500">Nairobi, Kenya</li>
            </ul>
          </div>
        </div>
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-stone-500">
          <p>&copy; {new Date().getFullYear()} Riverside Transfers. All rights reserved.</p>
          {/* Always present, whether or not the visitor was ever shown the
              banner: someone the geo gate places outside the UK/EEA still needs
              a way to turn analytics off. */}
          <button
            type="button"
            onClick={reopenConsent}
            className="text-stone-500 hover:text-white transition-colors underline underline-offset-2"
          >
            Cookie settings
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
